import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import LoadingBar from '../components/Modules/LoadingBar';
import { Tabs, Tab } from 'react-bootstrap';
import AlertError from '../components/common/AlertError';
import Select from 'react-select';

import './ApiCalls.less';

const currentPeriodEndDate = new Date();

class ApiCallsView extends Component {
  getDetailsTable = (data) => {
    const rows = data.map((item, key) => (
      <tr key={key}>
        <td>{ moment(item.interval).utc().format('MM/DD/YYYY') || '' }</td>
        <td>{ item.service_name || '' }</td>
        <td>{ item.calls || '0' }</td>
        <td>{ item.type || '' }</td>
      </tr>
    ));
    return (
      <table className="sticky-enabled tablesorter" align="center">
        <thead>
          <tr>
            <th><span>Billing Period</span></th>
            <th><span>Service</span></th>
            <th><span>API Cals</span></th>
            <th><span>Type</span></th>
          </tr>
        </thead>
        <tbody >
          { this.props.period_selected && this.noDataFound(data)}
          { rows }
        </tbody>
      </table>
    );
  };

  getSummaryTable = (data) => {
    const rows = data.map((item, key) => (
      <tr key={key}>
        <td>{`${moment(item.start).utc().format('MM/DD/YYYY')} - ${moment(item.end || currentPeriodEndDate).utc().format('MM/DD/YYYY')}` || '' }</td>
        <td>{ item.usage || '0' }</td>
        <td>${ item.total_cost || '0.00' }</td>
      </tr>
    ));
    return (
      <table className="sticky-enabled tablesorter" align="center">
        <thead>
          <tr>
            <th><span>Billing Period</span></th>
            <th><span>API Cals</span></th>
            <th><span>Amount</span></th>
          </tr>
        </thead>
        <tbody>
          { this.noDataFound(data) }
          { rows }
        </tbody>
      </table>
    );
  };

  noDataFound = (data) => {
    if (data.length === 0 && this.props.dataReady) {
      return (
        <div className="ir-search-integrations-message">
          <div className="messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }
  };

  render() {
    if (!this.props.dataReady) return <LoadingBar />;
    const alertError = this.props.error ? <AlertError errors={this.props.error} /> : null;

    const tableDetailsData = this.props.usage || [];
    const tableSummaryData = this.props.periods || [];

    const periodDropdown = this.props.periods.map(item => ({ label: `${moment(item.start).utc().format('MM/DD/YYYY')} - ${moment(item.end || currentPeriodEndDate).utc().format('MM/DD/YYYY')}`, value: JSON.stringify({ period_start: item.start, period_end: item.end || currentPeriodEndDate }) }));

    if (!this.props.period_selected && this.props.periods.length > 0) {
      const mostRecentPeriod = this.props.periods[0];
      const initialValues = JSON.stringify({ period_start: mostRecentPeriod.start, period_end: mostRecentPeriod.end || currentPeriodEndDate });
      this.props.handleChange(initialValues);
    }
    return (
      <div className={this.props.type}>
        {alertError}
        <Tabs defaultActiveKey={1} id="apicalls" bsStyle="tabs">
          <Tab eventKey={1} title="Details">
            <div className="period-section">
              <div className="period">Period:</div>
              <div className="selectParent">
                <Select
                  options={periodDropdown}
                  onBlurResetsInput={false}
                  onSelectResetsInput={false}
                  onChange={this.props.handleChange}
                  simpleValue
                  value={JSON.stringify({ period_start: this.props.period_start, period_end: this.props.period_end })}
                  searchable />
              </div>
            </div>
            {this.getDetailsTable(tableDetailsData)}
          </Tab>
          <Tab eventKey={2} title="Summary">
            {this.getSummaryTable(tableSummaryData)}
          </Tab>
        </Tabs>
        {!this.props.dataReady && <LoadingBar />}
      </div>
    );
  }
}

ApiCallsView.defaultProps = {
  error: null,
  type: 'apicalls',
};

ApiCallsView.propTypes = {
  handleChange: PropTypes.func.isRequired,
  dataReady: PropTypes.bool.isRequired,
  usage: PropTypes.any.isRequired,
  period_selected: PropTypes.any.isRequired,
  periods: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
};

export default ApiCallsView;



// WEBPACK FOOTER //
// ./src/Integrations/ApiCallsView.js